/*
 * @Author: liujunhong
 * @Date: 2023/7/11
 * @Desc: 游戏物品被盗找回
 */

import React, { useEffect, useState } from 'react';
import Nav from '@/components/Nav';
import Title from '@/components/Title';
import './index.less';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { Captcha, GameServer } from 'gyyx-component-lib';
import { MinusCircleOutlined } from '@ant-design/icons';
import useSWR from 'swr';
import { getItemsStolenReasons } from '@/constants/api';
import { fetcher } from '@/utils/request';
import { LoginInfo } from '@/types';
import { NavLink, useOutletContext } from 'react-router-dom';
import { K_F_BID, RESPONSE_STATUS } from '@/constants';
import { ValidData } from 'gyyx-component-lib/es/interface';
import { createItemsRecovered } from '@/services/kf';
import Confirm from '@/components/Confirm';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { REGEX_NUM } from '@/constants/reg';
import { useSetAtom } from 'jotai';
import {  loginAtom } from '@/utils/atoms';

const OTHER = 7;

interface Reasons {
  code: number;
  isDel: null;
  reasonName: string;
}

const {TextArea} = Input;
const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 10},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 15},

  },
};

const formTailLayout = {
  wrapperCol: {span: 8, offset: 6},
};


const CreateSuccess = () => {
  return <div className="create_success">
    <p className="title">创建成功</p>
    <p>工作人员预计在<span>24小时内</span>处理完毕，</p>
    <p>请随时留意客服中心的处理进度！</p>
    <NavLink className="create_btn" to={'/kf/kfTrackIndex'}>我的服务跟踪</NavLink>
  </div>;

};

const Index = () => {

  const [form] = Form.useForm();
  const [selectedOther, setSelectedOther] = useState(false);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [lastItemRemoved, setLastItemRemoved] = useState(false);
  const [lastItemRemovedPet, setLastItemRemovedPet] = useState(false);
  const [visible, setVisible] = useState(false);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [errorTips, setErrorTips] = useState('');
  const [open, setOpen] = useState(false);
  const loginInfo: LoginInfo = useOutletContext();
  const setUpdateLogin = useSetAtom(loginAtom);
  

  useEffect(() => {
    if (!loginInfo?.isLogin) {
      setUpdateLogin({isLogin: false, visibleLogin: true});
    }
  }, [loginInfo?.isLogin]);


  const {data: res} = useSWR(getItemsStolenReasons, fetcher, {
    revalidateOnFocus: false,
  });


  const onChange = (checkedValues: any[]) => {
    setSelectedItems(checkedValues);
    if (lastItemRemoved) {
      form.setFieldsValue({'equipment': [{equipmentName: '', equipmentProperty: null, equipmentLevel: null}]});
      setLastItemRemoved(false);
    }
    if (lastItemRemovedPet) {
      form.setFieldsValue({'pet': [{petName: '', petLevel: null, petWuxue: '', petTech: ''}]});
      setLastItemRemovedPet(false);
    }
    if (!selectedItems.includes('jewelry')) {
      form.setFieldsValue({
        'jewelry': {
          necklaceName: '',
          necklaceProperty: '',
          jadeName: '',
          jadeProperty: '',
          braceletName: '',
          braceletProperty: '',
        },
      });
    }
  };

  const validatorFn = () => {
    if (!form.getFieldsValue()?.jewelry) {
      return Promise.reject('必填一项');
    }
    const {
      necklaceName,
      necklaceProperty,
      jadeName,
      jadeProperty,
      braceletName,
      braceletProperty,
    } = form.getFieldsValue().jewelry;
    if (!braceletProperty && !necklaceName && !necklaceProperty
      && !jadeName && !jadeProperty && !braceletName) {
      return Promise.reject('必填一项');
    }
    return Promise.resolve();
  };


  const onChangeReasons = (checkedValues: any[]) => {
    let bool = false;
    if (checkedValues.includes(OTHER)) {
      bool = true;
    }
    setSelectedOther(bool);

  };


  const onFinish = () => {
    if (!loginInfo?.isLogin) {
      setUpdateLogin?.({isLogin: false, visibleLogin: true});
      return;
    }
    setVisible(true);
  };

  const submitCaptcha = async (data: ValidData) => {
    setVisible(false);
    const {captcha, cookies, balanceCode} = data;
    const {
      stolenTime,
      gameId,
      serverId,
      role,
      stolenReasonsTypeId,
      equipment,
      equipmentMemo,
      otherStolenItem,
      pet,
      petMemo,
      stolenReasons,
      jewelry,
    } = form.getFieldsValue();

    const formatTime = stolenTime.format('YYYY-MM-DD');
    const params = {
      gameId, serverId, role, stolenReasonsTypeId,
      stolenReasons,
      stolenTime: formatTime,
      captcha, cookies, balanceCode,
      stolenItems: {
        equipment: equipment || [],
        equipmentMemo,
        otherStolenItem,
        pet: pet || [], petMemo,
        jewelry,
      },

    };
    createItemsRecovered(params).then(res => {
      if (res.retCode !== RESPONSE_STATUS.SUCCESS) {
        setErrorTips(res.message);
        setOpen(true);
        return;
      }
      setCreateSuccess(true);
    });

  };


  return <div className="kf_recovered_wrap">
    <Nav activeMenu="kfCenter"/>
    <div className="kf_main">
      <div className="kf_main_in">
        <Title style={{padding: 0, fontSize: '20px'}} title="游戏物品被盗找回"
               content={<img className="title_icon" src="//img.gyyxcdn.cn/kf/images/kf_question_ico.gif"
                             alt=""/>}></Title>


        <div className="recovered_form">
          {createSuccess && <CreateSuccess/>}
          {!createSuccess && <>
            <Form
              labelCol={{span: 6}}
              wrapperCol={{span: 18}}
              layout="horizontal"
              onFinish={onFinish}
              form={form}
            >
              <Form.Item label="被问账号">
                <span>{loginInfo?.account}</span>
              </Form.Item>

              <Form.Item label="游戏" name="gameId" rules={[{required: true, message: '必填'}]}>
                <Select className="form_item_input" placeholder="请选择">
                  <Select.Option value="2">问道</Select.Option>
                </Select>

              </Form.Item>
              <Form.Item label="服务器" name="serverId" rules={[{required: true, message: '必填'}]}>
                <GameServer isWeGame status="activation" setValueFn={(item: { code: number }) => {
                  form.setFieldsValue({serverId: item.code});
                }} serIptClassName="sel_input" serSelClassName="sel_btn"/>
              </Form.Item>

              <Form.Item label="角色名称" name="role" rules={[{required: true, message: '必填'}]}>
                <Input className="form_item_input" maxLength={30}/>
              </Form.Item>
              <Form.Item label="被盗时间" name="stolenTime" rules={[{required: true, message: '必填'}]}>
                <DatePicker locale={locale} placeholder="请选择"
                            disabledDate={(current) => current >= moment().endOf('day') || current < moment().subtract(15, 'days').startOf('day')}
                            className="form_item_input"/>
              </Form.Item>
              <Form.Item label="被盗原因" name="stolenReasonsTypeId" rules={[{required: true, message: '请至少选择一项'}]}>
                <Checkbox.Group onChange={onChangeReasons}>
                  <Row>
                    {res?.data.map((item: Reasons) => <Col span={8} key={item.code}>
                      <Checkbox value={item.code} style={{lineHeight: '32px'}}>
                        {item.reasonName}
                      </Checkbox>
                    </Col>)}
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              {selectedOther && <Form.Item name="stolenReasons"
                                           rules={[{required: selectedOther, message: '内容不能为空'}]} {...formTailLayout}>
                <Input className="form_item_input" maxLength={30}/>
              </Form.Item>}

              <Form.Item label="被盗物品" name="checkboxGroup">
                <Checkbox.Group onChange={onChange}>
                  <Row>
                    <Col span={24}>
                      <Checkbox value="equipment" style={{lineHeight: '32px'}}>
                        装备
                      </Checkbox>
                    </Col>

                    {selectedItems.includes('equipment') && (
                      <Col span={24}>
                        <Form.List name="equipment"
                                   initialValue={[{
                                     equipmentName: '',
                                     equipmentProperty: null,
                                     equipmentLevel: null,
                                   }]}>
                          {(fields, {add, remove}) => (
                            <>
                              {fields.map(({key, name, ...restField}) => (
                                <div key={key} style={{display: 'flex', flexWrap: 'wrap', margin: 8}}>
                                  <Col span={11}>
                                    <Form.Item
                                      label="装备名称"
                                      {...formItemLayout}
                                      {...restField}
                                      name={[name, 'equipmentName']}
                                      rules={[{required: true, message: '必填'}]}
                                    >
                                      <Input maxLength={25}/>
                                    </Form.Item>
                                  </Col>
                                  <Col span={11}>
                                    <Form.Item
                                      label="改造等级"
                                      labelCol={{span: 10}}
                                      wrapperCol={{span: 10}}
                                      {...restField}
                                      name={[name, 'equipmentLevel']}
                                      rules={[{required: true, message: '必填'}, {
                                        pattern: REGEX_NUM,
                                        message: '仅支持数字',
                                      }]}

                                    >
                                      <Input maxLength={4}/>
                                    </Form.Item>
                                  </Col>
                                  <MinusCircleOutlined style={{margin: '9px'}} onClick={() => {
                                    if (fields.length === 1) {
                                      const newArr = form.getFieldsValue().checkboxGroup.filter((item: string) => item !== 'equipment');
                                      form.setFieldsValue({
                                        'checkboxGroup': newArr,
                                      });
                                      setSelectedItems(newArr);
                                      setLastItemRemoved(true);
                                    }
                                    remove(name);
                                  }}/>
                                  <Col span={22}>
                                    <Form.Item
                                      label="属性"
                                      labelCol={{span: 5}}
                                      wrapperCol={{span: 16}}
                                      {...restField}
                                      name={[name, 'equipmentProperty']}
                                      rules={[{required: true, message: '必填'}]}
                                    >
                                      <Input maxLength={25}/>
                                    </Form.Item>
                                  </Col>
                                </div>
                              ))}
                              {fields.length < 5 && <Form.Item style={{textAlign: 'center'}}>
                                <Button onClick={() => add()} block style={{width: '120px'}}>
                                  增加一条
                                </Button>
                              </Form.Item>}
                            </>
                          )}
                        </Form.List>
                        <Col span={22}>
                          <Form.Item labelCol={{span: 5}}
                                     wrapperCol={{span: 17}} label="装备附加说明" name="equipmentMemo">
                            <TextArea autoSize={{minRows: 2, maxRows: 6}}/>
                          </Form.Item>
                        </Col>

                      </Col>
                    )}

                    <Col span={24}>
                      <Checkbox value="jewelry" style={{lineHeight: '32px'}}>
                        首饰
                      </Checkbox>
                    </Col>
                    {selectedItems.includes('jewelry') && (
                      <Row>
                        <Col span={11}>
                          <Form.Item
                            {...formItemLayout}
                            label="项链名称"
                            name={['jewelry', 'necklaceName']}
                            rules={[{

                              validator: (_, value) => {

                                if (!value && form.getFieldsValue()?.jewelry?.necklaceProperty) {
                                  return Promise.reject('必填');
                                }
                                return validatorFn();
                              },
                            }]}

                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            labelCol={{span: 10}}
                            wrapperCol={{span: 10}}
                            label="属性"
                            name={['jewelry', 'necklaceProperty']}
                            rules={[{
                              validator: (_, value) => {
                                if (!value && form.getFieldsValue()?.jewelry?.necklaceName) {
                                  return Promise.reject('必填');
                                }
                                return Promise.resolve();
                              },
                            }]}
                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            {...formItemLayout}
                            label="玉佩名称"
                            name={['jewelry', 'jadeName']}
                            rules={[{
                              validator: (_, value) => {
                                if (!value && form.getFieldsValue()?.jewelry?.jadeProperty) {
                                  return Promise.reject('必填');
                                }
                                return Promise.resolve();
                              },
                            }]}
                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            labelCol={{span: 10}}
                            wrapperCol={{span: 10}}
                            label="属性"
                            name={['jewelry', 'jadeProperty']}
                            rules={[{
                              validator: (_, value) => {
                                if (!value && form.getFieldsValue()?.jewelry?.jadeName) {
                                  return Promise.reject('必填');
                                }
                                return Promise.resolve();
                              },
                            }]}
                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            {...formItemLayout}
                            label="手镯名称"
                            name={['jewelry', 'braceletName']}
                            rules={[{
                              validator: (_, value) => {
                                if (!value && form.getFieldsValue()?.jewelry?.braceletProperty) {
                                  return Promise.reject('必填');
                                }
                                return Promise.resolve();
                              },
                            }]}
                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={11}>
                          <Form.Item
                            labelCol={{span: 10}}
                            wrapperCol={{span: 10}}
                            label="属性"
                            name={['jewelry', 'braceletProperty']}
                            rules={[{
                              validator: (_, value) => {
                                if (!value && form.getFieldsValue()?.jewelry?.braceletName) {
                                  return Promise.reject('必填');
                                }
                                return Promise.resolve();
                              },
                            }]}
                          >
                            <Input maxLength={25}/>
                          </Form.Item>
                        </Col>
                        <Col span={22}>
                          <Form.Item labelCol={{span: 5}}
                                     wrapperCol={{span: 17}} label="首饰附加说明" name={['jewelry', 'jewelryMemo']}>
                            <TextArea autoSize={{minRows: 2, maxRows: 6}}/>
                          </Form.Item>
                        </Col>
                      </Row>
                      // </Form.Item>
                    )}

                    <Col span={24}>
                      <Checkbox value="pet" style={{lineHeight: '32px'}}>
                        宠物
                      </Checkbox>
                    </Col>
                    {selectedItems.includes('pet') && (
                      <Col span={24}>
                        <Form.List name="pet"
                                   initialValue={[{petName: '', petLevel: null, petWuxue: '', petTech: ''}]}>
                          {(fields, {add, remove}) => (
                            <>
                              {fields.map(({key, name, ...restField}) => (
                                <div key={key}
                                     style={{display: 'flex', flexWrap: 'wrap', marginBottom: 8}}>
                                  <Col span={11}>
                                    <Form.Item
                                      label="宠物名称"
                                      {...restField}
                                      {...formItemLayout}
                                      name={[name, 'petName']}
                                      rules={[{required: true, message: '必填'}]}
                                    >
                                      <Input maxLength={25}/>
                                    </Form.Item>
                                  </Col>

                                  <Col span={11}>
                                    <Form.Item
                                      label="等级"
                                      {...restField}
                                      labelCol={{span: 10}}
                                      wrapperCol={{span: 10}}
                                      name={[name, 'petLevel']}
                                      rules={[{required: true, message: '必填'}, {
                                        pattern: REGEX_NUM,
                                        message: '仅支持数字',
                                      }]}
                                    >
                                      <Input maxLength={4}/>
                                    </Form.Item>
                                  </Col>
                                  <MinusCircleOutlined style={{margin: '9px'}} onClick={() => {

                                    if (fields.length === 1) {
                                      const newArr = form.getFieldsValue().checkboxGroup.filter((item: string) => item !== 'pet');
                                      form.setFieldsValue({
                                        'checkboxGroup': newArr,
                                      });
                                      setSelectedItems(newArr);
                                      setLastItemRemovedPet(true);
                                    }
                                    remove(name);
                                  }}/>
                                  <Col span={11}>
                                    <Form.Item
                                      label="武学"
                                      {...restField}
                                      {...formItemLayout}
                                      name={[name, 'petWuxue']}
                                      rules={[{required: true, message: '必填'}, {
                                        pattern: REGEX_NUM,
                                        message: '仅支持数字',
                                      }]}
                                    >
                                      <Input maxLength={10}/>
                                    </Form.Item>
                                  </Col>


                                  <Col span={22}>
                                    <Form.Item
                                      label="技能名称及等级"
                                      {...restField}
                                      className="form_item_level"
                                      labelCol={{span: 5}}
                                      wrapperCol={{span: 7}}
                                      name={[name, 'petTech']}
                                      rules={[{required: true, message: '必填'}]}
                                    >
                                      <Input maxLength={25}/>
                                    </Form.Item>
                                  </Col>

                                </div>
                              ))}
                              {
                                fields.length < 5 && <Col span={24}>
                                  <Form.Item style={{textAlign: 'center'}}>
                                    <Button onClick={() => add()} block style={{width: '120px'}}>
                                      增加一条
                                    </Button>
                                  </Form.Item>
                                </Col>
                              }
                            </>
                          )}
                        </Form.List>
                        <Col span={22}>
                          <Form.Item label="宠物附加说明" labelCol={{span: 5}}
                                     wrapperCol={{span: 17}} name="petMemo">
                            <TextArea autoSize={{minRows: 2, maxRows: 6}}/>
                          </Form.Item>
                        </Col>
                      </Col>
                    )}


                  </Row>
                </Checkbox.Group>
              </Form.Item>
              <Form.Item label="其他物品" labelCol={{span: 8}}
                         wrapperCol={{span: 13}} name="otherStolenItem" rules={[
                {
                  validator: (_, value) => {
                    if ((!value || !value.trim().length) && (!form.getFieldsValue().checkboxGroup?.length)) {
                      return Promise.reject('以上4项必填一项');
                    }
                    return Promise.resolve();
                  },
                },
              ]}>
                <TextArea autoSize={{minRows: 2, maxRows: 6}}/>
              </Form.Item>
              <Space style={{display: 'flex', justifyContent: 'center', marginLeft: '-173px'}} align="baseline">
                <Form.Item>
                  <Button type="primary" className="submit_btn operate_btn" htmlType="submit">
                    确认
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button htmlType="reset" className="reset_btn operate_btn">清空</Button>
                </Form.Item>
              </Space>
            </Form>
            <Captcha
              visible={visible}
              bId={K_F_BID}
              onSubmit={submitCaptcha}
              onClose={() => setVisible(false)}
            />
            <Confirm isClose={false} message={errorTips} open={open} onOk={() => setOpen(false)}/>
          </>}
        </div>
      </div>
    </div>
  </div>;
};
export default Index;




